'use client';

import { Heading } from '../../../components/Heading/Heading';
import { useClientHasRendered } from '@domain/session/useClientHasRendered';
import { useCoupon } from '@domain/premium/useCoupon';
import { useUserInfo } from '@domain/user/useUserInfo';
import { FREE_TRIAL_DAYS } from '@domain/premium/plans';

export const ProHeadlineSection = ({ couponCode }: { couponCode?: string }) => {
  const { premiumEndDate, isLoadingUser } = useUserInfo();
  const { coupon, isLoading: couponIsLoading } = useCoupon(couponCode);
  const clientHasRendered = useClientHasRendered();
  const userHasBeenPro =
    !!premiumEndDate &&
    clientHasRendered &&
    premiumEndDate.localeCompare(new Date().toString()) <= 0;

  if (couponIsLoading || isLoadingUser) {
    return <></>;
  }

  if (userHasBeenPro || coupon) {
    return (
      <Heading as="h1" className="mt-0 mb-3 text-center whitespace-pre-line md:text-left">
        {`Fishbrain Pro
        A smarter way to fish`}
      </Heading>
    );
  }

  return (
    <Heading as="h1" className="mt-0 mb-3 text-center whitespace-pre-line md:text-left">
      {' '}
      {`Try Fishbrain Pro 
                            ${FREE_TRIAL_DAYS} days for free`}{' '}
    </Heading>
  );
};
